import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { isIOS, isAndroidChrome } from '../../../helpers/serverRenderingUtils';
import Box from '../../shared/Box';
import Text from '../../shared/Text/index.tsx';

import styles from './styles.sass';

const cx = classnames.bind(styles);

const isMobile = () => isIOS() || isAndroidChrome();

const FieldInput = ({
  input: { name, onChange, value },
  meta: { error, valid, submitFailed },
  type,
  label,
  placeholder,
  maxCharacterLength,
  isInline,
  labelWidth,
  minNumberValue,
  autofocus,
}) => {
  const isShowingError = submitFailed && !valid;
  return (
    <Box width="100%">
      <label
        className={cx({ label: true, inlineLabel: isInline })}
        htmlFor={name}
      >
        <div
          className={cx({
            labelTextWrapper: true,
            labelTextWrapperInline: isInline,
          })}
          style={{ width: labelWidth }}
        >
          <Text color="#292f36" size="lg" marginBottom={10}>
            {label}
          </Text>
        </div>
        <input
          className={cx({
            input: true,
            inlineInput: isInline,
            numberInput: type === 'number',
            numberInputMobile: isMobile(),
            inputError: isShowingError,
          })}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          type={type}
          min={type === 'number' ? minNumberValue : null}
          autoFocus={autofocus}
        />
      </label>
      {isShowingError && (
        <Box display="flex" justifyContent="between" marginTop={4}>
          <div
            className={cx({
              errorText: true,
              errorTextVisible: isShowingError,
            })}
          >
            <Text color="#d0021b">{error}</Text>
          </div>
          {maxCharacterLength && (
            <Text size="sm" color="#7f8287">
              {`${value.length} / ${maxCharacterLength}`}
            </Text>
          )}
        </Box>
      )}
    </Box>
  );
};

FieldInput.defaultProps = {
  isInline: false,
  autofocus: false,
  labelWidth: null,
  maxCharacterLength: null,
  minNumberValue: 0,
  placeholder: null,
};

FieldInput.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    asyncValidating: PropTypes.bool,
    autofilled: PropTypes.bool,
    dirty: PropTypes.bool,
    dispatch: PropTypes.func,
    form: PropTypes.string,
    initial: PropTypes.string,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitFailed: PropTypes.bool,
    submitting: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool,
  }).isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['number', 'text']).isRequired,
  maxCharacterLength: PropTypes.number,
  labelWidth: PropTypes.number,
  isInline: PropTypes.bool,
  minNumberValue: PropTypes.number,
  autofocus: PropTypes.bool,
};
export { FieldInput };
